import { myToolbar } from './tools/toolbar.js';
import { beads } from './beads.js';
import { palette } from './palette.js';
import { productionMode } from './core/environment.js';

export const historie = {};

historie.newProject = () => {
    historie.actions = [];
    historie.index = 0;
    historie.actions.push([]);
    myToolbar.disableTool('Undo');
    myToolbar.disableTool('Redo');
    historie.recentState = {
        beads: [],
        palette: []
    };
    historie.attributes = [
        {
            name: 'beadLog',
            attributes: ['active', 'style'],
            find: element => beads.findBead(element.column, element.row),
            render: element => beads.render(element),
            array: () => beads.arr,
            logRows: true,
            recent: 'beads',
        },
        {
            name: 'paletteLog',
            attributes: ['fillColor', 'secondColor', 'description', 'finishName', 'id', 'inner'],
            find: element => b3.store.state.swatches[element.index],
            render: element => element.render(),
            array: () => b3.store.state.swatches,
            logRows: false,
            recent: 'palette',
        },
    ];
    historie.updateRecentState();
};

historie.addAction = ({myAction=null} = {}) => {

    const action = myAction || {};

    historie.attributes.forEach(obj => {
        action[obj.name] = historie.log(obj);
    });

    const somethingHappened = (
        action.beadLog.length ||
        action.paletteLog.length ||
        myAction
    ) ? true : false;

    if (!somethingHappened) return;

    // delete future

    if (historie.actions.length > historie.index + 1) {
        myToolbar.disableTool('Redo');
        historie.actions = historie.actions.slice(0, historie.index + 1);
    }

    myToolbar.enableTool('Undo');
    if (loggedIn) myToolbar.enableTool('Cloud');

    // warn user about unsaved work
    window.onbeforeunload = productionMode && loggedIn ?
        () => true:
        null;

    historie.actions.push(action);
    historie.index++;
    historie.updateRecentState();
};

historie.log = obj => {
    let result = [], myLog = null, changeHappened = false;

    obj.array().forEach((element, i) => {
        myLog = {
            oldState: {},
            newState: {}
        };

        if (obj.logRows) {
            myLog.row = element.row;
            myLog.column = element.column;
        } else {
            myLog.index = i;
        }

        changeHappened = false;

        if (historie.recentState[obj.recent][i] !== undefined) {
            obj.attributes.forEach(a => {
                if (element[a] !== historie.recentState[obj.recent][i][a]) {
                    changeHappened = true;
                    myLog.oldState[a] = historie.recentState[obj.recent][i][a];
                    myLog.newState[a] = element[a];
                }
            });
        }

        if (changeHappened) {
            result.push(myLog);
            obj.attributes.forEach(a => {
                historie.recentState[obj.recent][i][a] = element[a];
            });
        }
    });

    return result;
};

historie.load = (action, backInTime) => {

    beads.unselectAll();

    let assignHistory = (a, b, attributes) => {
        if (a !== undefined && (b !== undefined)) {
            attributes.forEach(attr => {
                if (b[attr] !== undefined) {
                    a[attr] = b[attr];
                }
            });
        }
    };

    if (action.deleteSwatch === undefined) {
        // regular load history
        historie.attributes.forEach(obj => {
            if (action[obj.name] !== null) {
                action[obj.name].forEach(element => {
                    let myRecord = obj.find(element);
                    let source = backInTime ? element.oldState : element.newState;
                    assignHistory(myRecord, source, obj.attributes);
                    obj.render(myRecord);
                });
            }
        });
    } else {
        // special case: deleting and restoring swatches
        if (action.deleteSwatch != backInTime) { // equivalent to XOR operator
            // delete
            let mySwatch = b3.store.state.swatches.find(element => element.id == action.swatch.id);
            palette.deleteSwatch(mySwatch, false); // delete without creating new history action
        } else {
            // restore
            palette.addSwatch({
                fillColor: action.swatch.fillColor,
                description: action.swatch.description,
                finishName: action.swatch.finishName,
                inner: action.swatch.inner,
                secondColor: action.swatch.secondColor,
                letterCode: action.swatch.letterCode,
                addHistory: false, // don't add history
                position: action.position, // where to put the swatch back
                id: action.swatch.id // need to restore with same ID
            });
        }
    }

    beads.refreshCanvas();
    historie.updateRecentState();
};

historie.updateRecentState = () => {
    historie.recentState = {
        beads: [],
        palette: []
    };

    historie.attributes.forEach(obj => {
        obj.array().forEach((element, i) => {
            let record = {};
            obj.attributes.forEach(a => {
                record[a] = element[a];
            });
            historie.recentState[obj.recent].push(record);
        });
    });
};

historie.undo = () => {
    if (historie.index > 0) {
        myToolbar.enableTool('Redo');
        historie.load(historie.actions[historie.index], true);
        historie.index--;
    }
    if (historie.index == 0) myToolbar.disableTool('Undo');
};

historie.redo = () => {
    if (historie.actions.length > historie.index + 1) {
        myToolbar.enableTool('Undo');
        historie.index++;
        historie.load(historie.actions[historie.index], false);
    }
    if (historie.actions.length == historie.index + 1) myToolbar.disableTool('Redo');
};